import createIcon from '../../createIcon';

/**
 * @component @name Filter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuOTYgMTAuMjlMMTMuMjEgMTMuODNMMTEuMjUgMTEuNDdMOC41IDE1SDE5LjVMMTUuOTYgMTAuMjlaTTMgNUgxVjIxQzEgMjIuMSAxLjkgMjMgMyAyM0gxOVYyMUgzVjVaTTIxIDFIN0M1LjkgMSA1IDEuOSA1IDNWMTdDNSAxOC4xIDUuOSAxOSA3IDE5SDIxQzIyLjEgMTkgMjMgMTguMSAyMyAxN1YzQzIzIDEuOSAyMi4xIDEgMjEgMVpNMjEgMTdIN1YzSDIxVjE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Filter = createIcon('Filter', [
  [
    'path',
    {
      d: 'M15.96 10.29L13.21 13.83L11.25 11.47L8.5 15H19.5L15.96 10.29ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z',
      key: 'riyh0w',
    },
  ],
]);

export default Filter;
